import { assignExportTables, getAll, create, destroy } from 'redux/api/ApiKeys'

import { Dispatch } from 'redux'
import { toggleSnackbarOpen } from '../Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'
import { ApiKeyType } from 'types/GlobalApiKey'
import { useThunkActions } from '../useThunkActions'
import * as actions from './actions'

function tryGetAllApiKeys() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

function tryCreateApiKey(body: { name: string; type: ApiKeyType }) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    create(body)
      .then((response) => {
        dispatch(actions.createSuccess(response.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.ApiKeyCreated))
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.ApiKeyCreatedFailed))
      })
  }
}

function tryDeleteApiKey(id: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    destroy(id)
      .then(() => {
        dispatch(actions.destroySuccess(id))

        dispatch(toggleSnackbarOpen(SnackbarMessage.ApiKeyDeleted))
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.ApiKeyDeletedFailed))
      })
  }
}

function tryAssignExportTablesToApiKey(
  id: string,
  exportTableIds: string[],
  removedExportTableIds: string[]
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.assignExportTablesToApiKey())

    assignExportTables(id, exportTableIds)
      .then(() => {
        dispatch(
          actions.assignExportTablesToApiKeySuccess({
            id,
            exportTableIds,
            removedExportTableIds
          })
        )

        dispatch(
          toggleSnackbarOpen(SnackbarMessage.ExportTablesAssignedToApiKey)
        )
      })
      .catch(() => {
        dispatch(actions.assignExportTablesToApiKeyFailed())

        dispatch(
          toggleSnackbarOpen(SnackbarMessage.ExportTablesAssignedToApiKeyFailed)
        )
      })
  }
}

export const useApiKeyActions = () => {
  return {
    tryGetAllApiKeys: useThunkActions(tryGetAllApiKeys),
    tryCreateApiKey: useThunkActions(tryCreateApiKey),
    tryDeleteApiKey: useThunkActions(tryDeleteApiKey),
    tryAssignExportTablesToApiKey: useThunkActions(
      tryAssignExportTablesToApiKey
    )
  }
}
